import { NgModule } from '@angular/core';
import { DatePickerComponent } from './date-picker/datepicker.component';
import { DisplayErrorComponent } from './error/display-error.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MainLayoutFooterComponent } from '../shared/common/layout/main-layout-footer/main-layout-footer.component';
import { MainLayoutHeaderComponent } from '../shared/common/layout/main-layout-header/main-layout-header.component';
import { QuestionComponent } from '@app/shared/common/question/question.component';
import { NavTabComponent } from '@app/shared/common/nav-tab/nav-tab.component';
import { EmailComponent } from '@app/shared/common/email/email.component';
import { RadioComponent } from '@app/shared/common/radio/radio.component';
import { KidComponent } from '@app/shared/common/kid/kid.component';
import { DobComponent } from '@app/shared/common/dob/dob.component';
import { RouterModule } from '@angular/router';
import { PopupContent } from '@app/shared/common/popup-content/popup-content.component';
import { MyNeedsPipe } from '@app/shared/common/pipes/my-needs.pipe';
import { NationalitiesPipe } from '@app/shared/common/pipes/nationalities-filter.pipe';
import { MyFinancialPipe } from '@app/shared/common/pipes/my-financial.pipe';
import {
  SliderCustomIconComponent,
  SingleSliderComponent,
  SliderTicksLabelsComponent
} from '@app/shared/slider';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { AreaChartComponent } from '@app/shared/common/area-chart/area-chart.component';
import { GaugeChartComponent } from '@app/shared/common/gauge-chart/gauge-chart';
import 'hammerjs';
import { MyDatePickerModule } from 'mydatepicker';
import { MatSliderModule } from '@angular/material';
import { RangeAreaChartMySavingComponent } from '@app/shared/common/range-area-chart-my-saving/range-area-chart-my-saving.component';
import { RangeAreaChartIncomeProtectionComponent } from '@app/shared/common/range-area-chart-income-protection/range-area-chart-income-protection.component';
import { SubmitDialogComponent } from '@app/shared/submit-dialog/submit-dialog.component';
import { LoadingOverlayComponent } from '@app/shared/loading-overlay/loading-overlay.component';
import { SingpassErrorModalComponent } from '@app/shared/singpass-error-modal/singpass-error-modal.component';

@NgModule({
  declarations: [
    DatePickerComponent,
    DisplayErrorComponent,
    MainLayoutFooterComponent,
    MainLayoutHeaderComponent,
    EmailComponent,
    RadioComponent,
    DobComponent,
    KidComponent,
    QuestionComponent,
    NavTabComponent,
    PopupContent,
    MyNeedsPipe,
    SliderCustomIconComponent,
    RangeAreaChartMySavingComponent,
    SingleSliderComponent,
    AreaChartComponent,
    GaugeChartComponent,
    SliderTicksLabelsComponent,
    RangeAreaChartIncomeProtectionComponent,
    SubmitDialogComponent,
    LoadingOverlayComponent,
    SingpassErrorModalComponent,
    NationalitiesPipe,
    MyFinancialPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ChartsModule,
    MyDatePickerModule,
    MatSliderModule
  ],
  entryComponents: [SubmitDialogComponent],
  exports: [
    DatePickerComponent,
    DisplayErrorComponent,
    MainLayoutFooterComponent,
    MainLayoutHeaderComponent,
    EmailComponent,
    RadioComponent,
    DobComponent,
    KidComponent,
    QuestionComponent,
    NavTabComponent,
    PopupContent,
    MyNeedsPipe,
    SliderCustomIconComponent,
    RangeAreaChartMySavingComponent,
    SingleSliderComponent,
    AreaChartComponent,
    GaugeChartComponent,
    SliderTicksLabelsComponent,
    MatSliderModule,
    RangeAreaChartIncomeProtectionComponent,
    SubmitDialogComponent,
    LoadingOverlayComponent,
    SingpassErrorModalComponent,
    NationalitiesPipe,
    MyFinancialPipe
  ]
})
export class ShareModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts